











import Loader from '@/components/common/Loader.vue';
import { Component, Vue } from 'vue-property-decorator';
import { tokenService } from '@/services/TokenService';
import { authService } from '../services/AuthService';

@Component({
  components: { Loader },
})
export default class Logout extends Vue {
  mounted() {
    const token = tokenService.getToken();
    authService
      .logout(token as string)
      .then(() => {
        tokenService.removeToken();
        this.$router.push('/login').catch(() => {});
      })
      .catch(() => {
        tokenService.removeToken();
        this.$router.push('/login').catch(() => {});
      });
  }
}
